module.exports = __webpack_public_path__ + "img/img-eat-06.b2fa4b4d.png";